import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Spinner } from './components/ui'
import DashboardLayout from './dashboard/Layout'
import LoginPage from './dashboard/LoginPage'

const ReviewApp = lazy(() => import('./review/ReviewApp'))
const RequestsBoard = lazy(() => import('./dashboard/RequestsBoard'))
const RequestDetail = lazy(() => import('./dashboard/RequestDetail'))
const ProjectsPage = lazy(() => import('./dashboard/ProjectsPage'))
const ProjectPage = lazy(() => import('./dashboard/ProjectPage'))
const TeamPage = lazy(() => import('./dashboard/TeamPage'))

function Loading() {
  return (
    <div className="flex min-h-[50dvh] items-center justify-center">
      <Spinner />
    </div>
  )
}

export default function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/r/:token" element={<ReviewApp />} />
        <Route path="/login" element={<LoginPage />} />
        <Route element={<DashboardLayout />}>
          <Route index element={<Navigate to="/requests" replace />} />
          <Route path="/requests" element={<RequestsBoard />} />
          <Route path="/requests/:id" element={<RequestDetail />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:id" element={<ProjectPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="*" element={<Navigate to="/requests" replace />} />
        </Route>
      </Routes>
    </Suspense>
  )
}
